(function(){
  function initMobileThumbs(){
    if(window.innerWidth>749)return;
    document.querySelectorAll('[data-section-type="product"]').forEach(function(root){
      var thumbs=[].slice.call(root.querySelectorAll('[data-product-media-thumbnail]'));
      var medias=[].slice.call(root.querySelectorAll('[data-product-media]'));
      if(!thumbs.length||!medias.length)return;
      function activate(id){
        thumbs.forEach(function(t){
          var on=String(t.getAttribute('data-media-id'))===String(id);
          t.classList.toggle('nt-thumb-active',on);
          t.classList.toggle('thumb-active',on);
          if(on&&t.scrollIntoView)t.scrollIntoView({behavior:'smooth',inline:'center',block:'nearest'});
        });
      }
      thumbs.forEach(function(t){
        t.addEventListener('click',function(){setTimeout(function(){activate(t.getAttribute('data-media-id'))},80);});
      });
      if('IntersectionObserver' in window){
        var obs=new IntersectionObserver(function(entries){
          var best=null;
          entries.forEach(function(e){if(e.isIntersecting&&(!best||e.intersectionRatio>best.intersectionRatio))best=e;});
          if(best){var id=best.target.getAttribute('data-media-id');if(id)activate(id);}
        }, {root:null,threshold:[.55,.7,.85]});
        medias.forEach(function(m){obs.observe(m);});
      }
      var first=root.querySelector('[data-product-media]');
      if(first)activate(first.getAttribute('data-media-id'));
    });
  }
  document.addEventListener('DOMContentLoaded',initMobileThumbs);
  document.addEventListener('shopify:section:load',initMobileThumbs);
})();